import { fromJS } from "immutable"

const initCustomerData = fromJS([])

const initFilterCustomer= fromJS({
  customerCode:'',
  customerName:'',
  group1:'',
  group2:'',
  npwp:'',
  pageNo:1,
  pageSize:10,
})

export function filterCustomer(
  state = initFilterCustomer,
  action
){
  switch (action.type) {
    case "FILTER_SET_CUSTOMER_CODE_SUCCESS":
      return state.set('customerCode', action.customerCode)
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set('customerName', action.customerName)
    case "FILTER_SET_GROUP_1_SUCCESS":
      return state.set('group1', action.group1)
    case "FILTER_SET_GROUP_2_SUCCESS":
      return state.set('group2', action.group2)
    case "FILTER_SET_NPWP_SUCCESS":
      return state.set('npwp', action.npwp)
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set('pageNo', action.pageNo)
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set('pageSize', action.pageSize)
    default:
      return state;
  }
 
}

export function customerData(
  state = initCustomerData,
  action
) {
  switch (action.type) {
    case "CUSTOMER_FETCH_DATA_SUCCESS":
      return fromJS(action.dataCustomer);
    default:
      return state;
  }
}
